export const assignedEmpListColumns = [
    {
      Header: 'Id',
      accessor: 'id',
    },
    {
      Header: 'Emp Name',
      accessor: 'empName',
    },
    {
      Header: 'Shift',
      accessor: 'shift',
    },
    {
      Header: 'Roster Start',
      accessor: 'rosterStart',
    },
    {
      Header: 'Roster End',
      accessor: 'rosterEnd',
    },
    {
      Header: 'Actions',
      accessor: 'actions',
    }
  ];

  export const assignedEmpListTableData = [
    {   
        id:'1',
        empName:'Jony Morg',
        shift:'Morning Shift',
        rosterStart: '2024-01-11',
        rosterEnd: '2024-01-26',
    },
    {   
        id:'2',
        empName:'Alka Murty',
        shift:'Night Shift',
        rosterStart: '2021-12-01',
        rosterEnd: '2022-10-24',
    },
    {   
        id:'3',
        empName:'Tommy Leo',
        shift:'Morning Shift, Night Shift',
        rosterStart: '2021-11-21',
        rosterEnd: '2021-11-30',
    },
    {   
        id:'4',
        empName:'Panda Prty',
        shift:'Night Shift',
        rosterStart: '2024-12-01',
        rosterEnd: '2024-10-24',
    },
    {   
        id:'5',
        empName:'Aky Reo',
        shift:'Morning Shift, Night Shift',
        rosterStart: '2023-11-21',
        rosterEnd: '2023-11-30',
    },
    {   
      id:'6',
      empName:'Samuel Johnson',
      shift:'Morning Shift',
      rosterStart: '2024-05-01',
      rosterEnd: '2024-05-15',
    },
    {   
      id:'7',
      empName:'Emily Watson',
      shift:'Night Shift',
      rosterStart: '2024-06-01',
      rosterEnd: '2024-06-15',
    },
    {   
      id:'8',
      empName:'Chris Evans',
      shift:'Morning Shift, Night Shift',
      rosterStart: '2024-07-01',
      rosterEnd: '2024-07-15',
    },
    {   
      id:'9',
      empName:'Lucy Liu',
      shift:'Night Shift',
      rosterStart: '2024-08-01',
      rosterEnd: '2024-08-15',
    },
    {   
      id:'10',
      empName:'Michael Jordan',
      shift:'Morning Shift, Night Shift',
      rosterStart: '2024-09-01',
      rosterEnd: '2024-09-15',
    },
]